<div class="move-conflict">
    <div class="conflict-container" *ngIf="actionStep === moveActionStep.ONE_CONFLICT || actionStep === moveActionStep.MANY_CONFLICT">
        <div class="alert-container">
            <sync-alert [type]="'warning'" [leadIcon]="'warning'" [showLeadIcon]="true"
                [description]="'A file or folder with this name already exists in this location.'" [showActions]="false"
                [showCloseButton]="false" />
        </div>
        <div class="body body-1" *ngIf="actionStep === moveActionStep.ONE_CONFLICT">
            <div class="conflict-text">An item named “{{conflictFileName}}” already exists in “{{destinationName}}”.</div>
            <div class="conflict-text"> Do you want to keep both or replace the existing item?</div>
        </div>
        <div class="body body-1" *ngIf="actionStep === moveActionStep.MANY_CONFLICT">
            <ng-container *ngIf="actionMoveOrCopy === webpathActionType.MOVE">
                <div class="conflict-text" >We found {{conflictTotalCount}} items in “{{destinationName}}” that already exist with the same names.</div>
                <div class="conflict-text"> Do you want to fix these issues?</div>
            </ng-container>
            <ng-container *ngIf="actionMoveOrCopy === webpathActionType.COPY">
                <div class="conflict-text" >{{conflictTotalCount}} items in “{{destinationName}}” already exist with the same names.</div>
                <div class="conflict-text"> Do you want to review these issues?</div>
            </ng-container>
        </div>
    </div>
    <div class="multiple-conflict-container" *ngIf="actionStep === moveActionStep.FIX_CONFLICT">
        <div class="body body-1">
            <div class="conflict-text">An item named <strong>"{{conflictFileName}}"</strong> already exists in “{{destinationName}}”.</div>
            <div class="conflict-text"> Choose an action to fix this issue.</div>
            <div class="checkbox-container">
                <sync-checkbox [label]="checkboxLabel" [checked]="applyConflictForAll" [indeterminate]="false"
                    [disabled]="false" [onChange]="checkboxChange"></sync-checkbox>
            </div>
        </div>
    </div>
</div>